import React, { useState, useEffect, useRef } from "react";
import { getMenuDetails } from "../Services/menu-service";
import Account from "./Account";
import { useLocation } from "react-router-dom";
import { showWarning, showSuccess } from "./utility/ui/notifications/Toaster";
import WINotesDocument from "../Assests/documents/wi_notes.jpg";
import { ICONS } from "./utility/common/constants/icons";
import MainComponent from "./MainComponent";

const Header = (props) => {
  const childRef = useRef();
  const [labels, setLabels] = useState({
    title: "Dashboard",
    button: false,
    buttontext: "",
    currentMenu: "DASHBOARD",
    heading: "",
  });
  

  let location = useLocation().pathname;
  let lastElement;
  let Title;

  const GetNav = () => {
    lastElement = location.replace(/[\W_]/g, " > ");
    lastElement = lastElement.slice(1, lastElement.lastIndexOf(">"));
    lastElement = lastElement.replace("weldingmaster", "Welding Master");
    lastElement = lastElement.replace("wps", "WPS Transaction");
    lastElement = lastElement.replace("maintenance", "Maintenance");
    lastElement = lastElement.replace("raiseDeviation", "Raise Deviation");
    lastElement = lastElement.replace("groove", "Raise Deviation");
    lastElement = lastElement.replace("PQRTransaction", "PQR Transaction");
    lastElement = lastElement.replace("TubetoTubesheet", "Tube to Tubesheet");
    lastElement = lastElement.replace("Wpqlinking", "Wpq Linking");
    return lastElement;
  };

  const getTitle = (location) => {
    let innerpage = location.slice(
      location.lastIndexOf("/") + 1,
      location.length
    );

    Title = labels?.title;
    switch (innerpage) {
      case "WCSdetail":
        Title = "WCS Detail";
        break;
      case "Npcil":
        Title = "NPCIL Project to WPQ Linking";
        break;
      case "/":
        Title = "";
        break;
    }
    return Title;
  };

  const next = async (e) => {
    if (labels.button.toLowerCase() === "true") await childRef.current.handleAdd();
  };

  const handleWINotesDownload = async () => {
    const userRole = sessionStorage.getItem("Role");

    if (userRole?.toLowerCase() !== "admin") {
      showWarning("Only Admin can download the file.");
      return;
    }

    try {
      const link = document.createElement("a");
      link.href = WINotesDocument;
      link.download = "wi_notes.jpg";
      link.click();
      link.remove();
      showSuccess("WI Notes downloaded successfully");

    } catch (error) {
      console.error("Download failed:", error);
      showWarning("Failed to download WI Notes. Please contact administrator.");
    }
  };

  const isWITransactionPage = location === "/WITransaction";

  useEffect(() => {
    let result1;
    result1 = sessionStorage.getItem("UserAccess");
    if (result1 !== undefined && result1 !== null)
      setLabels(getMenuDetails(result1, window.location.pathname));

    if (location && location.indexOf("unauthorized") !== -1)
      setLabels({
        title: "Unauthorized",
        button: false,
        buttontext: "",
        currentMenu: "Unauthorized",
        heading: "Unauthorized",
      });
  }, [location]);

  return (
    <>
      <div className="headerrow">
        <div
          className="title"
          style={{
            fontSize: "24px",
            width: "max-content",
            position: "relative", top: "8px",
          }}>
          <b>
            {(() => {
              if (labels?.heading !== undefined) {
                return labels?.heading;
              }
              if (labels?.title === undefined && location === "/") {
                return "";
              }
              return labels?.title;
            })()}
          </b>
        </div>
        <div className="btn-add" style={{ display: 'flex' }}>
          {labels?.button == "TRUE" && (
            <button type="button" className="add-btn" onClick={(e) => next(e)}>
              {" "}
              <div className="text">
                <img src={ICONS.AddIcon}></img>{"   "}
                {labels?.buttontext}
              </div>
            </button>
          )}
          {isWITransactionPage && (
            <div
              className="wi-notes-download"
              onClick={handleWINotesDownload}
              title="Download WI Notes"
              onMouseEnter={(e) => {
                const img = e.currentTarget.querySelector('img');
                img.src = ICONS.Download_Blue_Big;
              }}
              onMouseLeave={(e) => {
                const img = e.currentTarget.querySelector('img');
                img.src = ICONS.Download_Grey_Big;
              }}
            >
              <img
                src={ICONS.Download_Grey_Big}
                alt="Download WI Notes"
              />
              <span>WI Notes</span>
            </div>
          )}
        </div>
        <div className="account1">
          <Account />
        </div>
      </div>
      {getTitle(location) !== undefined && (
        <div className={"location"}>
          <div className="ltext">
            {" "}
            Home
            {GetNav()}
            {"> "}
            <a>{getTitle(location)}</a>
          </div>
        </div>
      )}
      <MainComponent childRef={childRef}></MainComponent>
    </>
  );
};

export default Header;